import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer({ onBook }) {
  const { t } = useI18n();
  return (
    <footer className="relative bg-black border-t border-white/10 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-b border-white/10 pb-16">
          <div className="flex items-center gap-4 mb-6">
            <img src="/logo-vico-round.png" alt="Vico's Scooter" className="h-14 w-14 object-contain" data-testid="footer-logo" />
            <div className="font-heading font-black text-white tracking-tighter text-2xl">VICO<span className="text-scooter-yellow">'S</span> SCOOTER</div>
          </div>
          <h2 className="font-heading font-black text-scooter-yellow text-7xl sm:text-9xl lg:text-[10rem] leading-none tracking-tighter">{t.footer.tag}</h2>
          <div className="mt-8 flex justify-between items-end flex-wrap gap-6">
            <p className="text-zinc-400 max-w-md">San Cassiano · Corvara · La Villa · Colfosco · Alta Badia</p>
            <button onClick={onBook} className="bg-scooter-yellow text-black font-bold text-xs tracking-[0.2em] uppercase px-8 h-14 hover:bg-scooter-yellow-hover transition-colors" data-testid="footer-book-btn">{t.nav.book}</button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-12">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-4">{t.footer.contact}</div>
            <div className="space-y-2">
              <a href="mailto:info@vicotravel.it" className="flex items-center gap-2 text-zinc-300 hover:text-scooter-yellow transition-colors text-sm" data-testid="footer-email"><Mail className="w-4 h-4" /> info@vicotravel.it</a>
              <a href="tel:+393356116528" className="flex items-center gap-2 text-zinc-300 hover:text-scooter-yellow transition-colors text-sm" data-testid="footer-phone"><Phone className="w-4 h-4" /> +39 335 6116528</a>
              <a href="https://instagram.com/vicotravel.dolomites" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-zinc-300 hover:text-scooter-yellow transition-colors text-sm" data-testid="footer-instagram"><Instagram className="w-4 h-4" /> @vicotravel.dolomites</a>
            </div>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-4">{t.footer.location}</div>
            <div className="flex items-start gap-2 text-zinc-300 text-sm" data-testid="footer-address"><MapPin className="w-4 h-4 mt-0.5 text-scooter-yellow shrink-0" /><span>Via Glira 4<br/>39036 San Cassiano in Badia (BZ)<br/>Alto Adige · Italia</span></div>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-4">{t.footer.hours}</div>
            <div className="text-zinc-300 text-sm space-y-1">
              <div>Mon–Sun · 08:30 — 19:30</div>
              <div className="text-zinc-500">Open every day · summer season</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex items-center justify-between text-xs text-zinc-600 flex-wrap gap-2">
          <span>© {new Date().getFullYear()} Vico's Scooter · {t.footer.rights}</span>
          <div className="flex items-center gap-5">
            <span className="tracking-[0.3em] uppercase">IT · EN · DE</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
